module.exports = __webpack_public_path__ + "img/home-banner-right.688a9637.png";